import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Seo from "@/components/Seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Events()
{
    const router = useRouter();
    return (
        <>
            <Seo
                title="Live Polling for Events | Audience Engagement Tool for Conferences"
                description="Increase audience participation at conferences, workshops, and events using live polling software built for real-time feedback."
                canonical="https://instantpolls.online/events"
            />
            <section className="hero-reseller events-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Events & Conferences</h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white" >
                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold  mb-4 publicTextNew">
                                Turn audiences <br />into participants.
                            </h2>
                            <p className="text-muted mb-3">
                                Every event thrives on energy — the reactions, ideas, and moments of connection that make it memorable. But without <b> real-time feedback</b>, it’s hard to know what’s landing, who’s truly engaged, and how your message is resonating.</p>
                            <p className="text-muted mb-3">
                                Whether you’re running a  <b>corporate conference</b>, panel discussion, or live keynote, our <b> event technology</b> captures sentiment in real time. Our <b> live polling software </b> allows you to read the room, adapt on the fly, and create an <b>interactive event</b> experience that feels alive</p>
                            <p className="text-muted">
                                Because when you prioritize <b>audience engagement</b>, participation skyrockets — and every event becomes more meaningful.                            </p>

                        </div>

                        <div className="col-lg-6 text-center">
                            <Image src="/industry/live-events-audience-polling.png" alt="live events audience polling software" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Challenge</h5>
                                    <p className="card-text text-muted">
                                        Traditional <b> event feedback </b> happens after the fact — usually through <b> post-event surveys </b> that few complete and data that arrives too late to act on. That’s not insight. That’s hindsight.</p>
                                    <p className="card-text text-muted">
                                        <b>Event organisers</b>, keynote speakers, and hosts need a way to understand their audience as it happens. Without <b> real-time audience interaction</b>, it is impossible to respond to the mood, spark conversation, and deliver the <b>interactive experiences</b> that attendees expect.                                        </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Solution</h5>
                                    <p className="card-text text-muted">
                                        Our <b>AI-powered event analytics</b> reveal <b> audience sentiment </b> and trends in real time, while <b> custom branding</b> ensures your event experience feels seamless and professional. Built for scale, our platform features <b> enterprise-grade privacy, sponsor-ready integrations</b>, and flexible <b>pay-per-use pricing</b>.                                    </p>
                                    <p className="card-text text-muted"> No delays. No waiting for <b> post-event reports </b>. Just <b>instant connection</b> and the <b> real-time insights </b> that keep your event alive, responsive, and highly interactive. </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Result</h5>
                                    <p className="card-text text-muted">
                                        Instant Polls transforms audiences from observers into <b> active contributors</b>. It fuels <b>real-time interaction</b>, strengthens speaker impact, and delivers <b> measurable engagement </b> that your sponsors and stakeholders can see.
                                    </p>
                                    <p className="card-text text-muted">The result? <b>Interactive events</b> that feel dynamic, inclusive, and unforgettable—where every voice counts and every moment matters. By capturing <b>audience insights</b> live, you provide the <b> event ROI </b> that proves your strategy worked.</p>
                                    <p className="card-text text-muted">Because the best events don’t just talk at people—they use <b> interactive technology </b> to talk with them.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>

                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section-events d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 publicPageNewTextColor">Make learning live, <br />engaging, and measurable.</h3>
                            <p className="text-muted mb-3">
                                Discover how Instant Polls transforms <b> audience feedback </b>into active participation,
                                making every keynote or <b>hybrid event</b> more impactful. Whether you’re hosting a <b> corporate conference </b> or
                                leading <b> professional development</b>, our tools provide the real-time analytics and connection that make content stick.
                                By prioritising <b> audience engagement</b>,
                                you ensure every session is data-driven, interactive, and effective.                            </p>
                            <p className="text-muted mb-4">
                                {"Whether you're teaching, training, or leading professional development, Instant Polls gives you the clarity and connection that make learning stick."}
                            </p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2" >BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
Events.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;

